import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatButtonModule } from '@angular/material/button';
import { DtypeComponentListComponent } from "../dtype-component-list/dtype-component-list.component";

@Component({
    selector: 'dtype-filter',
    imports: [TranslocoPipe, MatButtonModule, DtypeComponentListComponent],
    templateUrl: './dtype-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dtype-filter.component.scss'
})
export class DtypeFilterComponent {
    @Input() filterDTypeForm: DTypeForm;
    @Input() showFilters: boolean;

    clearFilter () {
        this.filterDTypeForm.control.reset();
    }
    
}